import script from "./LowerHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LowerHeader.vue?vue&type=script&lang=ts&setup=true"

import "./LowerHeader.vue?vue&type=style&index=0&id=36ec305c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ec305c"]])

export default __exports__